var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "view",
  "use": "view-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"view\"><g><rect fill=\"#241F20\" height=\"29.498\" width=\"21.07\" y=\"-0.033\" /><rect fill=\"#241F20\" height=\"29.498\" width=\"21.07\" x=\"26.93\" y=\"18.535\" /><rect fill=\"#241F20\" height=\"13.695\" width=\"21.07\" x=\"26.93\" y=\"-0.033\" /><rect fill=\"#241F20\" height=\"13.695\" width=\"21.07\" y=\"34.338\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id